/* @flow */

import { compose } from 'ramda';
import * as React from 'react';

const ClientErrorMain = (): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Effects
   |----------------------------------------------------------------------------
   */

  React.useEffect(() => {
    throw Error('Test - A client synchronous error');
  }, []);

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return <section></section>;
};

export default compose(React.memo)(ClientErrorMain);
